import React, { memo } from "react";
import { Button } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";

import { TPositionFormItem } from "~/pages/BaseStaff/EmployeeProfileEditor/EmployeeProfileForm/model/types";

import s from "~/pages/BaseStaff/EmployeeProfileEditor/EmployeeProfileForm/EmployeeProfileForm.less";

interface IFormFooterProps {
  positions: TPositionFormItem[];
  licensesLoaded: boolean;
  isAdd: boolean;
  isSubmitting: boolean;
  pendingSendCheck: boolean;
  onSave: () => void;
  onSendCheck: () => void;
  onRequestLicense: () => void;
}

const FormFooter = ({
  positions,
  licensesLoaded,
  isAdd,
  isSubmitting,
  pendingSendCheck,
  onSave,
  onSendCheck,
  onRequestLicense,
}: IFormFooterProps) => {
  const { t } = useTranslation();

  // TODO PASDILER-2428: временно скрыты лицензионная плашка и валидация до завершения работ в feat/PASDILER-1829. https://task.sotl.group:8443/browse/PASDILER-2428
  // const licenseSendBlocked = useMemo(
  //   () => !isAdd && licensesLoaded && hasLicenseSendBlock(positions),
  //   [isAdd, licensesLoaded, positions],
  // );
  // const showLicenseNotice = licenseSendBlocked;
  // const canRequestLicenses = canRequestTrainingLicenses();
  // const noticeDescription = canRequestLicenses
  //   ? t("employee.trainingLicenseNoticeDescription")
  //   : t("employee.trainingLicenseNoticeDescriptionNoAction");

  return (
    <>
      <hr className={s.sectionDivider} />

      <div className={s.footer}>
        {/* {showLicenseNotice && (
          <NoticeBanner
            className={s.footerNotice}
            role="alert"
            title={t("employee.trainingLicenseNoticeTitle")}
            description={noticeDescription}
            actions={
              canRequestLicenses
                ? [
                    {
                      label: t("employee.requestLicense"),
                      onClick: onRequestLicense,
                    },
                  ]
                : undefined
            }
          />
        )} */}
        <div className={s.buttons}>
          <Button
            bold
            color="primary"
            fontSize="14"
            size="medium"
            radius={5}
            loading={isSubmitting && !pendingSendCheck}
            onClick={onSave}
          >
            {t("ui.save")}
          </Button>
          {!isAdd && (
            <Button
              color="secondary"
              fontSize="14"
              size="medium"
              radius={5}
              loading={isSubmitting && pendingSendCheck}
              onClick={onSendCheck}
            >
              {t("ui.sendCheck")}
            </Button>
          )}
        </div>
      </div>
    </>
  );
};

export default memo(FormFooter);
